import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, getUserListings, createListing } from '../firebase';
import './HostingListings.css';

function HostingListings() {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    location: '',
    price: '',
    beds: '',
    baths: '',
    description: '',
    airbnbUrl: '',
  });
  const [photos, setPhotos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchListings();
  }, []);

  const fetchListings = async () => {
    try {
      const userListings = await getUserListings(auth.currentUser.uid);
      setListings(userListings);
    } catch (error) {
      alert('Failed to fetch listings');
    }
    setLoading(false);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhotoChange = (e) => {
    setPhotos(Array.from(e.target.files));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title || !formData.location || !formData.price || photos.length === 0) {
      alert('Please fill in all required fields and upload photos');
      return;
    }

    try {
      await createListing(auth.currentUser.uid, {
        ...formData,
        price: parseInt(formData.price),
        beds: parseInt(formData.beds) || 0,
        baths: parseInt(formData.baths) || 0,
      }, photos);
      alert('Listing created successfully!');
      setFormData({
        title: '',
        location: '',
        price: '',
        beds: '',
        baths: '',
        description: '',
        airbnbUrl: '',
      });
      setPhotos([]);
      setShowForm(false);
      fetchListings();
    } catch (error) {
      alert('Failed to create listing');
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="hosting-listings">
      <div className="listings-header">
        <h2>Your Listings</h2>
        <button 
          onClick={() => setShowForm(!showForm)}
          className="create-listing-btn"
        >
          {showForm ? '✕ Cancel' : '+ Create New Listing'}
        </button>
      </div>

      {showForm && (
        <div className="create-form-container">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <input
                type="text"
                name="title"
                placeholder="Listing Title"
                value={formData.title}
                onChange={handleFormChange}
                required
              />
              <input
                type="text"
                name="location"
                placeholder="City/Location"
                value={formData.location}
                onChange={handleFormChange}
                required
              />
            </div>
            <div className="form-row">
              <input
                type="number"
                name="price"
                placeholder="Monthly Price ($)"
                value={formData.price}
                onChange={handleFormChange}
                required
              />
              <input
                type="number"
                name="beds"
                placeholder="Bedrooms"
                value={formData.beds}
                onChange={handleFormChange}
              />
              <input
                type="number"
                name="baths"
                placeholder="Bathrooms"
                value={formData.baths}
                onChange={handleFormChange}
              />
            </div>
            <textarea
              name="description"
              placeholder="Description"
              value={formData.description}
              onChange={handleFormChange}
              rows="4"
            />
            <input
              type="url"
              name="airbnbUrl"
              placeholder="Airbnb Listing URL (optional)"
              value={formData.airbnbUrl}
              onChange={handleFormChange}
            />
            <div className="photo-input">
              <label>Upload Photos (required)</label>
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={handlePhotoChange}
                required
              />
              <p>{photos.length} photos selected</p>
            </div>
            <button type="submit" className="submit-btn">Create Listing</button>
          </form>
        </div>
      )}

      {listings.length === 0 && !showForm ? (
        <div className="empty-state">
          <p>You haven't listed any properties yet</p>
          <button 
            onClick={() => setShowForm(true)}
            className="create-first-btn"
          >
            Create Your First Listing
          </button>
        </div>
      ) : (
        <div className="listings-table">
          <div className="table-header">
            <div className="col col-image">Photo</div>
            <div className="col col-title">Title</div>
            <div className="col col-location">Location</div>
            <div className="col col-price">Price</div>
            <div className="col col-actions">Actions</div>
          </div>
          {listings.map((listing) => (
            <div 
              key={listing.id} 
              className="table-row"
              onClick={() => navigate(`/hosting/listing/${listing.id}`)}
            >
              <div className="col col-image">
                <img src={listing.photos[0]} alt={listing.title} />
              </div>
              <div className="col col-title">{listing.title}</div>
              <div className="col col-location">{listing.location}</div>
              <div className="col col-price">${listing.price}/mo</div>
              <div className="col col-actions" onClick={(e) => e.stopPropagation()}>
                <button 
                  className="action-btn view-btn"
                  onClick={() => navigate(`/hosting/listing/${listing.id}`)}
                >
                  Manage
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default HostingListings;
